import { Form } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<typeof Form.Item>

export const SearchFormItem: FC<Props> = ({
  className,
  children,
  ...props
}) => {
  return (
    <Form.Item {...props} className={clsx(['!mb-0 max-w-[100%]', className])}>
      {children}
    </Form.Item>
  )
}
